import "./image_group.css";
